import { createFileRoute } from "@tanstack/react-router";

import { ActAsPanel } from "../../../../workspaces/settings/platform/ActAsPanel";

export const Route = createFileRoute("/_console/settings/platform/act-as")({
  component: ActAsPanel,
});
